const newCategory = {
  id: null,
  name: ""
};

export default newCategory;
